import { render, staticRenderFns } from "./FiDataField.vue?vue&type=template&id=4ab4c426&scoped=true&lang=pug&"
import script from "./FiDataField.vue?vue&type=script&lang=js&"
export * from "./FiDataField.vue?vue&type=script&lang=js&"
import style0 from "./FiDataField.vue?vue&type=style&index=0&id=4ab4c426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4c426",
  null
  
)

export default component.exports